import request from '@/utils/request'


// 查询用户分享关系绑定列表
export function listInviteRecord(query) {
  return request({
    url: '/user/inviteRecord/list',
    method: 'get',
    params: query
  })
}

// 查询用户分享关系绑定分页
export function pageInviteRecord(query) {
  return request({
    url: '/user/inviteRecord/page',
    method: 'get',
    params: query
  })
}

// 团队成员
export function teamMembersPage(query) {
  return request({
    url: '/user/inviteRecord/teamMembersPage',
    method: 'get',
    params: query
  })
}

// 查询用户分享关系绑定详细
export function getInviteRecord(data) {
  return request({
    url: '/user/inviteRecord/detail',
    method: 'get',
    params: data
  })
}

// 新增用户分享关系绑定
export function addInviteRecord(data) {
  return request({
    url: '/user/inviteRecord/add',
    method: 'post',
    data: data
  })
}

// 修改用户分享关系绑定
export function updateInviteRecord(data) {
  return request({
    url: '/user/inviteRecord/edit',
    method: 'post',
    data: data
  })
}

// 删除用户分享关系绑定
export function delInviteRecord(data) {
  return request({
    url: '/user/inviteRecord/delete',
    method: 'post',
    data: data
  })
}
